import React, { useState } from "react";
import InputGroup from "react-bootstrap/InputGroup";
import { Form } from "react-bootstrap";
import { FormControl } from "../";
import { faCaretUp, faCaretDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const FormControlIncrement = ({ field, form, value, onChange, ...rest }) => {
  const [focusClass, setFocusClass] = useState("");
  const [initialValue, setInitialValue] = useState(value);
  const disabled = rest.disabled;

  const Increment = () => {
    onChange(parseInt(value) + 1);
  };
  const decrement = () => {
    onChange(parseInt(value) - 1);
  };
  const onDollarInputFocus = () => {
    setFocusClass("focus");
  };

  //   const onDollarInputBlur = (e) => {
  //     const { handleBlur } = rest;
  //     if (e.target.value) e.target.value = parseFloat(e.target.value)?.toFixed(2);
  //     setFocusClass("");
  //     handleBlur(e);
  //   };

  return (
    <div className="d-flex">
      <FormControl {...field} {...form} {...rest} size="xs">
        <InputGroup className={`input-dollar-wrapper ${focusClass}`}>
          <Form.Control
            {...field}
            {...rest}
            style={{
              borderRadius: "5px",
              width: "40px",
              flexGrow: 0,
            }}
            onFocus={onDollarInputFocus}
          />
          {/* <InputGroup.Append>
        </InputGroup.Append> */}
        </InputGroup>
      </FormControl>

      <div
        className="d-flex flex-column ml-2"
        style={{ marginTop: "25px", color: "#BDBDBD", fontSize: "20px" }}
      >
        <FontAwesomeIcon icon={faCaretUp} onClick={Increment} />
        <FontAwesomeIcon icon={faCaretDown} onClick={decrement} />
      </div>
    </div>
  );
};

export default FormControlIncrement;
